module.exports = __webpack_public_path__ + "img/ico-calendar.ce276c43.svg";